var _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGasIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FF77F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 30,
    cy: 30,
    r: 26.25,
    fill: "#FF77F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 22.5,
    fill: "#FF77F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 34.3269V26.5384V22.4807C19.75 21.9284 20.1977 21.4807 20.75 21.4807H39.25C39.8023 21.4807 40.25 21.9284 40.25 22.4807V28.2692V37.5192C40.25 38.0715 39.8023 38.5192 39.25 38.5192H20.75C20.1977 38.5192 19.75 38.0715 19.75 37.5192V36.0576V34.3269Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30L41 30",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 39.5193V40.2501C22.5 40.8023 22.9477 41.2501 23.5 41.2501H36.5C37.0523 41.2501 37.5 40.8023 37.5 40.2501V39.5193",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21V19C24 18.4477 24.4477 18 25 18H35C35.5523 18 36 18.4477 36 19V21",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasIcon);
export default __webpack_public_path__ + "static/media/gasIcon.63a3b02e3154b7bb8e1392bca3a31527.svg";
export { ForwardRef as ReactComponent };